import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { ReadyNotifications } from "../components/ReadyNotifications";

export default function NotifichePage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.notifiche} />
      <ReadyNotifications />
    </div>
  );
}
